import React, { useState, useEffect } from 'react';
import { Clock, Truck, Shield, CreditCard, Heart, CheckCircle } from 'lucide-react';

interface BannerContent {
  title: string;
  subtitle: string;
  ctaText: string;
  ctaLink: string;
  backgroundImage: string;
  paymentMessage: string;
  paymentHighlight: string;
}

export const Hero: React.FC = () => {
  const [bannerContent, setBannerContent] = useState<BannerContent>({
    title: 'Motos Honda com até 35% OFF',
    subtitle: 'Entrega em casa • Você só paga quando receber',
    ctaText: 'Ver Motos Disponíveis',
    ctaLink: 'https://wa.me/5513996763208',
    backgroundImage: '',
    paymentMessage: 'VOCÊ SÓ PAGA QUANDO RECEBER!',
    paymentHighlight: 'Sem risco, sem complicação!'
  });

  useEffect(() => {
    const savedContent = localStorage.getItem('bannerContent');
    if (savedContent) {
      setBannerContent(JSON.parse(savedContent));
    }
  }, []);

  return (
    <section className="bg-gradient-to-br from-primary-600 to-primary-800 text-white py-16 lg:py-24">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h1 className="text-4xl lg:text-6xl font-bold mb-4 animate-fade-in">
            {bannerContent.title}
          </h1>
          <p className="text-xl lg:text-2xl mb-8 opacity-90">
            {bannerContent.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={bannerContent.ctaLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-lg px-8 py-4"
            >
              {bannerContent.ctaText}
            </a>
            <a
              href="https://wa.me/5513996763208"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary text-lg px-8 py-4 bg-white text-primary-600 hover:bg-gray-100"
            >
              Falar no WhatsApp
            </a>
          </div>
        </div>

        {/* Destaque Principal - Pague ao Receber */}
        <div className="mt-12 bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8 max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-6">
            <div className="bg-green-400 text-green-900 p-4 rounded-full">
              <Heart size={32} />
            </div>
            <div className="text-center md:text-left">
              <h3 className="text-2xl font-bold mb-2">🎯 {bannerContent.paymentMessage}</h3>
              <p className="text-lg opacity-90">
                Entregamos sua moto em casa e você só paga ao receber. 
                <span className="font-bold text-yellow-300">{bannerContent.paymentHighlight}</span>
              </p>
              <div className="flex items-center justify-center md:justify-start mt-3 space-x-2">
                <CheckCircle className="text-green-300" size={20} />
                <span className="text-sm">100% Seguro • Garantia de Satisfação</span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          <div className="text-center">
            <div className="bg-white bg-opacity-20 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <Clock size={32} />
            </div>
            <h3 className="font-semibold mb-2">Entrega Rápida</h3>
            <p className="text-sm opacity-90">Entregamos em até 48h</p>
          </div>
          
          <div className="text-center">
            <div className="bg-white bg-opacity-20 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <Truck size={32} />
            </div>
            <h3 className="font-semibold mb-2">Frete Grátis</h3>
            <p className="text-sm opacity-90">Para todo o estado</p>
          </div>
          
          <div className="text-center">
            <div className="bg-white bg-opacity-20 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <Shield size={32} />
            </div>
            <h3 className="font-semibold mb-2">Garantia Total</h3>
            <p className="text-sm opacity-90">1 ano de fábrica</p>
          </div>
          
          <div className="text-center">
            <div className="bg-white bg-opacity-20 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <CreditCard size={32} />
            </div>
            <h3 className="font-semibold mb-2">Facilidades</h3>
            <p className="text-sm opacity-90">Parcelamos em até 48x</p>
          </div>
        </div>
      </div>
    </section>
  );
};